const query = (id, isPreview) => `
{
  imageWithText(id: "${id}", preview: ${isPreview}) {
    heading
    descriptionForImage
    leftHeading
    description
        cameoImages {
    internalTitle
    altText
    cameoMediumMobile {
      title
      description
      url
    }
    cameoMedium {
      title
      description
      url
    }
    cameoLargeMobile {
      title
      description
      url
    }
    cameoLarge {
      title
      description
      url
    }
  }
    buttonLink {
      label
      title
      url
      target
      scrollToElementId
      gaEventClass
      gaEventLabel
      ariaLabel
      image {
        title
        description
        url
        width
        height
      }
      
    }
    isReversed
    elementId
    showBackground
    variant
    isLinkBelowImage
    mainHeading
    categoryLinksCollection{
      items{
        name
      url
      label
      title
      target
      scrollToElementId
      imageType
      gaEventClass
      gaEventLabel
      ariaLabel
      }
    }
    images {
          internalTitle
          altText
          imageDesktop {
            title
            description
            url
            width
            height
          }
          imageMobile {
            title
            description
            url
            width
                height
          }
          bgDesktop {
            title
            description
            url
            width
            height
          }
          bgMobile {
            title
            description
            url
            width
            height
          }
        }
    backgroundImage {
      title
      description
      url
      width
      height
    }
    link {
      label
      title
      url
      target
      scrollToElementId
      gaEventClass
      gaEventLabel
      ariaLabel
      image {
        title
        description
        url
        width
        height
      }
      
    }
    video{
    title
    isCaption
    variant
    youtubeVideoId
    isButtonBlack
    isImageToggle
    posterImage{
        altText
         imageDesktop {
            title
            description
            url
            width
            height
          }
          imageMobile {
            title
            description
            url
            width
            height
          }
      }
      isModal
      isCareerPage
  }
  }
}

`
module.exports = { query }
